<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row [label]="'wbo.report.edit.options'">
                <fui-two-columns>
                    <fui-column>
                        <wbo-single-select-edit-control [(ngModel)]="model.data.unemployed"
                                                        [allowClearSelectionOption]="false"
                                                        [formControlName]="'unemployed'">
                            <wbo-select-options>
                                <wbo-select-option [value]="true" label="wbo.employee-details-report.options.unemployed.excluded"></wbo-select-option>
                                <wbo-select-option [value]="false" label="wbo.employee-details-report.options.unemployed.included"></wbo-select-option>
                            </wbo-select-options>
                        </wbo-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <wbo-employee-report-selection></wbo-employee-report-selection>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
